import { Injectable } from '@angular/core';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location/models/location-config.interface';
import { ILocationMapState } from '@ordersnproducts/modules/order-builder/modules/location/reducers/location-map-reducer/location-map.reducer';
import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { SHIPPING_CONDITION_CODE } from '@ordersnproducts/modules/shared/constants/shipping-conditions-codes';
import { formConfig } from '@ordersnproducts/modules/order-builder/modules/location/configs/form-config';
import { ProductLineCodesTypes } from '@cemex-core/cmx-api/models/business-lines/product-lines-codes';

@Injectable()
export class LocationPageConfigService {
  private _configBase: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState };

  get configBase(): { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } {
    return this._configBase;
  }

  set configBase(value: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState }) {
    this._configBase = value;
  }

  constructor() {}

  public getConfigBasedOnInitialized(
    country: COUNTRY_CODE,
    businessLine: ProductLineCodesTypes,
    deliveryMethod: SHIPPING_CONDITION_CODE,
  ): { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } {
    if (country === null || businessLine === null || deliveryMethod === null) {
      throw new Error('Loader is not properly initialised. Forgot to call "generateForm" method?');
    }

    try {
      this.configBase = formConfig[country][businessLine][deliveryMethod];
      return this.configBase;
    } catch (e) {
      throw new Error(
        `Config for combination of country: "${country}", businessLine: "${businessLine}", ` +
          `deliveryMethod: "${deliveryMethod}" does not exist.`,
      );
    }
  }
}
